const formatUkPostcode = (postcode: unknown): string | undefined => {
  if (typeof postcode !== 'string') return undefined;

  const trimmed = postcode.trim();
  if (!trimmed) return undefined;

  const cleaned = trimmed.replace(/\s+/g, '').toUpperCase();
  const match = /^([A-Z]{1,2}[\dR][\dA-Z]?)(\d[A-BD-HJLNP-UW-Z]{2})$/.exec(cleaned);
  if (!match) return trimmed;

  const [, outwardCode, inwardCode] = match;
  return `${outwardCode} ${inwardCode}`;
};

export { formatUkPostcode };
